import { render, staticRenderFns } from "./MenuToolbar.vue?vue&type=template&id=a435f504&scoped=true"
import script from "./MenuToolbar.vue?vue&type=script&lang=ts"
export * from "./MenuToolbar.vue?vue&type=script&lang=ts"
import style0 from "./MenuToolbar.vue?vue&type=style&index=0&id=a435f504&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a435f504",
  null
  
)

export default component.exports